import React from 'react';
import { connect, getIn } from 'formik';
import { Switch } from '@ccm-office/ccm-ui';
import { FormControl, FormControlLabel, Grid, makeStyles } from '@material-ui/core';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  label: {
    minWidth: 300,
    paddingTop: 9,
    marginLeft: 0,
  },
  switch: {},
}));

function isFunction(functionToCheck) {
  const isFunction = {}.toString.call(functionToCheck);
  return (
    functionToCheck &&
    (isFunction === '[object Function]' || isFunction === '[object AsyncFunction]')
  );
}

const SwitchField = connect(
  ({
    name,
    label,
    offLabel,
    labelPlacement = 'top',
    onChangeFromPage,
    formik: { values, handleChange },
    classes,
    labelClass,
    ...props
  }) => {
    const value = Boolean(getIn(values, name));

    const onChange = (e) => {
      e.target.value = e.target.checked;
      if (onChangeFromPage && isFunction(onChangeFromPage)) {
        onChangeFromPage(e);
      }
      handleChange(e);
    };

    const cssClass = useStyles();

    return (
      <FormControl>
        <Grid container>
          <FormControlLabel
            control={
              <Switch
                data-testid={`switch-${name}`}
                name={name}
                checked={value}
                color="primary"
                onChange={onChange}
                className={cssClass.switch1}
                classes={classes}
                disabled={props.disabled}
              />
            }
            label={
              <span
                data-testid={`label-${name}`}
                className={classnames(cssClass.label, labelClass)}
              >
                {!value && offLabel ? offLabel : label}
              </span>
            }
            labelPlacement={labelPlacement}
          />
        </Grid>
      </FormControl>
    );
  }
);

export default SwitchField;
